import { makeStyles } from "@material-ui/core/styles";

export const useChangePasswordStyles = makeStyles(theme => ({
  section: {
    marginTop: "19px",
    padding: "20px",
    paddingLeft: "8px",
    color: "#fff",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "4px",
      marginTop: "0",
      padding: "24px 0 163px",
    },
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 48,
    [theme.breakpoints.down("sm")]: {
      gap: 32,
    },
  },
  sectionTitle: {
    color: "#fff",
    fontSize: "32px",
    fontWeight: 700,
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
  },
  sectionSubTitle: {
    color: "#fff",
    fontSize: "24px",
    fontWeight: 700,
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
  infoText: {
    color: "#F0F0F0",
    fontWeight: 400,
    fontSize: "14px",
    font: "Roboto",
    width: 452,
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      fontWeight: 400,
      width: "100%",
    },
  },
  form: {
    paddingTop: "16px",
  },
  passwordField: {
    marginBottom: "24px",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "16px",
    },
  },
  passwordTitle: {
    color: "#FFFFFF",
    fontSize: "14px",
    font: "Roboto",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  inputField: {
    border: "1px solid #747474",
    borderRadius: 8,
    marginTop: "8px",
    width: "452px",
    fontSize: 16,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    "& .MuiInputBase-root": {
      color: "white",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#EDECED",
      },
      "&:hover fieldset": {
        borderColor: "#f06ec4",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#f06ec4",
      },
    },
    "& .MuiInputLabel-root": {
      color: "#999999",
    },
  },
  sectionFooter: {
    [theme.breakpoints.down("sm")]: {
      marginTop: "0px",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      paddingTop: 16,
    },
  },
  saveButton: {
    width: "452px",
    height: "32px",
    backgroundColor: "#FE5A97",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#d45ca5",
    },
    textTransform: "none",
    border: "1px solid #363636",
    borderRadius: "6px",
    padding: "20px 16px",
    minHeight: 60,
    fontSize: "20px",
    fontWeight: 600,
    font: "Roboto",
    [theme.breakpoints.down("sm")]: {
      width: "348px",
      fontSize: "14px",
      maxHeight: "38px",
      minHeight: "14px",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  cancelButton: {
    width: "75px",
    height: "40px",
    backgroundColor: "#FFFFFF",
    color: "#344054",
    border: "1px solid #363636",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: 600,
    font: "Roboto",
    textTransform: "none",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      fontSize: "13px",
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    marginTop: "46px",
    columnGap: "12px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column-reverse",
      alignItems: "stretch",
      marginTop: "2px",
      gap: "12px",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  temporaryDeactivate: {
    color: "#f06ec4",
    fontSize: "12px",
    cursor: "pointer",
    textAlign: "center",
    margin: "20px 0 10px 0",
    [theme.breakpoints.down("sm")]: {
      fontSize: "11px",
    },
  },
}));
